<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <b-card no-body>
      <b-card-body>
        <div class="chat-wrapper">
          <b-row class="chat-inner">
            <!-- Left -->

            <b-col
              lg="4"
              class="d-flex align-items-start chat-history my-1"
            >
              <div class="w-100">
                <div class="d-flex justify-content-between">
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    class="mb-1 font-weight-bold"
                    :style="
                      !isSmallScreen ? 'cursor: default' : 'cursor: pointer'
                    "
                    @click="isSmallScreen ? (visible = !visible) : ''"
                  >
                    แชททั้งหมด
                  </b-button>
                  <div class="d-flex justify-content-center">
                    <b-form-select
                      v-model="filter"
                      size="sm"
                      :options="filterOptions"
                      @change="ChatAll()"
                    />
                  </div>
                </div>
                <b-collapse :visible="visible">
                  <div>
                    <b-card-title>
                      <b-form-input
                        v-model="searchQuery"
                        :size="isSmallScreen ? 'sm' : 'md'"
                        placeholder="ค้นหา"
                        @keyup.enter="ChatAll"
                      />
                    </b-card-title>

                    <b-list-group style="max-height: 60vh; overflow-y: auto">
                      <b-list-group-item
                        v-for="item in chatMessages"
                        :key="item.id"
                        :class="{
                          'active-chat':
                            currentChat[0] &&
                            currentChat[0].username === item.username,
                        }"
                        style="cursor: pointer"
                        @click="selectChat(item)"
                      ><div>
                         <b-avatar
                           :class="{
                             'online-status': !item,
                             'offline-status': item,
                           }"
                           src="/chatuser.webp"
                           size="30px"
                           class="mr-1"
                         />
                         <span class="font-weight-bold">{{
                           item.username
                         }}</span>
                         <span
                           v-if="item.unseenMsgs"
                           class="badge badge-danger ml-2"
                           style="
                              box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
                              float: right;
                            "
                         >
                           {{ item.unseenMsgs }}
                           <span v-if="isSmallScreen">+</span>
                           <span v-if="!isSmallScreen">ข้อความใหม่</span>
                         </span>
                       </div>
                        <div class="mx-2">
                          <b-collapse :visible="visible">
                            <span
                              v-if="item.checkChat == 1"
                              class="badge badge-warning ml-2"
                              style="box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4)"
                            >
                              ดำเนินการโดย {{ item.agentChat }}
                            </span>

                            <span
                              v-if="item.checkChat == 2"
                              class="badge badge-success ml-2"
                              style="box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4)"
                            >
                              เสร็จสิ้น
                            </span></b-collapse>
                        </div>
                      </b-list-group-item>
                      <div
                        v-if="chatMessages.length > 0"
                        class="d-flex justify-content-between flex-wrap mt-1"
                      >
                        <!-- page length -->
                        <b-form-group class="text-nowrap">
                          <b-form-select
                            id="perPageSelect"
                            v-model="perPage"
                            size="sm"
                            inline
                            :options="pageOptions"
                            @change="ChatAll()"
                          />
                        </b-form-group>

                        <!-- pagination -->
                        <div>
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            first-number
                            last-number
                            prev-class="prev-item"
                            next-class="next-item"
                            @input="ChatAll()"
                          >
                            <template #prev-text>
                              <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                              />
                            </template>
                            <template #next-text>
                              <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                              />
                            </template>
                          </b-pagination>
                        </div>
                      </div>
                    </b-list-group>
                  </div>
                </b-collapse>
              </div>
            </b-col>

            <div
              v-if="!firstchat"
              class="d-flex justify-content-center align-items-center mx-auto"
              :style="isSmallScreen === true ? 'height: 50vh' : 'height: 80vh'"
            >
              <div class="e-card playing">
                <div class="image" />
                <div class="wave" />
                <div class="wave" />
                <div class="wave" />

                <div class="infotop">
                  <b-img
                    src="/admin.webp"
                    alt="Background Image"
                    style="max-width: 100px; margin-bottom: 10px"
                    fluid
                  /><br>
                  เริ่มการสนทนา
                  <br>
                  <div class="name">
                    กรุณาเลือกลูกค้าที่ต้องการคุย
                  </div>
                </div>
              </div>
            </div>
            <!-- Right -->
            <b-col
              v-if="firstchat"
              lg="8"
              class="d-flex flex-column chat-box"
            >
              <b-card-title
                title-tag="h2"
                class="font-weight-bold d-flex justify-content-between align-items-center head"
              >
                <div
                  class="mt-1 d-flex justify-content-center align-items-center"
                  style="font-size: 16px"
                >
                  <b-avatar
                    :class="{
                      'online-status': firstchat,
                      'offline-status': firstchat,
                    }"
                    src="/chatuser.webp"
                    size="30px"
                    class="mr-1"
                  />
                  {{ currentChat[0].username }}
                </div>

                <div
                  v-if="socket"
                  class="d-flex flex-wrap justify-content-end align-items-center"
                >
                  <div
                    v-if="socket.checkChat != 2"
                    class="mt-1"
                  >
                    <b-button
                      style="box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5)"
                      :variant="socket.checkChat == 1 ? 'warning' : 'info'"
                      size="sm"
                      @click="EndManage(socket, socket.checkChat ? 0 : 1)"
                    >
                      {{ socket.checkChat ? "กำลังดำเนินการ" : "ดำเนินการ" }}
                    </b-button>
                  </div>

                  <div
                    v-if="socket.checkChat != 2"
                    class="ml-1 mt-1"
                  >
                    <b-button
                      style="box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5)"
                      variant="success"
                      size="sm"
                      @click="EndManage(socket, 2)"
                    >
                      สิ้นสุดดำเนินการ
                    </b-button>
                  </div>
                  <div
                    v-if="socket.checkChat == 2"
                    class="ml-1 mt-1"
                  >
                    <b-button
                      style="box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5)"
                      variant="primary"
                      size="sm"
                      @click="EndManage(socket, 0)"
                    >
                      อินบ็อกซ์
                    </b-button>
                  </div>
                </div>
              </b-card-title>

              <!-- Display chat history -->
              <div
                ref="chatHistoryBox"
                class="chat-history-box"
              >
                <div
                  v-for="(msg, index) in currentChat"
                  :key="msg.id"
                  style="position: relative"
                  class="message mt-1"
                  :class="{
                    'user-message': msg.roleSend === 'user',
                    'admin-message': msg.roleSend === 'admin',
                  }"
                >
                  <div
                    v-if="!isSmallScreen ? isNewDay(msg, index) : ''"
                    style="
                      position: absolute;
                      top: 0;
                      left: 50%;
                      transform: translateX(-50%);
                      border-radius: 0.75rem;
                      background-color: #f1f1f1;
                      max-width: 6rem;
                      margin: auto;
                      padding: 0.125rem;
                      width: 100%;
                      text-align: center;
                      font-size: 0.75rem;
                      margin-bottom: 0.25rem;
                    "
                  >
                    {{ getDateHeader(msg.created_at) }}
                  </div>
                  <b-avatar
                    v-if="msg.roleSend !== 'admin'"
                    src="/chatuser.webp"
                    size="25px"
                    class="mr-1"
                  />
                  <div
                    v-if="msg.roleSend === 'admin'"
                    class="text-nowrap"
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: end;
                      justify-content: end;
                      margin-inline: 5px;
                      margin-top: 10px;
                      font-size: 9px;
                    "
                  >
                    <span>{{ msg.unseenMsgs ? "อ่านแล้ว" : "" }}</span>

                    <span
                      v-if="msg.roleSend === 'admin'"
                      :id="'message-' + index"
                    >
                      {{ formatDate2(msg.created_at) }}
                    </span>
                  </div>

                  <div
                    v-if="msg.roleSend === 'admin'"
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: end;
                      justify-content: center;
                      margin-inline: 5px;
                      /* margin-top: 12px; */
                    "
                  >
                    <span
                      v-if="msg.message && msg.roleSend === 'admin'"
                      class="message-text"
                    >
                      {{ msg.message }}
                    </span>
                    <!-- <div
                      v-if="msg.message && msg.roleSend === 'admin'"
                      style="font-size: 9px; text-align: center"
                    >
                      dev_admin
                    </div> -->
                  </div>

                  <span
                    v-if="msg.message && msg.roleSend === 'user'"
                    class="message-text"
                  >
                    {{ msg.message }}
                  </span>
                  <div
                    v-if="msg.fileimg && msg.fileimg.length > 0"
                    class="message-text"
                  >
                    <b-img
                      v-for="(image, index) in msg.fileimg"
                      :key="index"
                      :src="GetImg('chat_img', image)"
                      fluid
                      :style="
                        !isSmallScreen
                          ? 'cursor: pointer; max-width: 300px; max-height: 100px;'
                          : 'max-width: 200px; max-height: 50px;'
                      "
                      @click="openImageModal(image)"
                    />
                  </div>
                  <span
                    v-if="msg.roleSend === 'user'"
                    :id="'message-' + index"
                    class="ml-1 mt-1 text-nowrap"
                    style="font-size: 9px"
                  >
                    {{ formatDate2(msg.created_at) }}
                  </span>
                  <b-popover
                    v-if="isSmallScreen"
                    variant="primary"
                    :target="'message-' + index"
                    triggers="hover"
                  >
                    {{ formatDate(msg.created_at) }}
                  </b-popover>

                  <div
                    v-if="msg.roleSend === 'admin'"
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: end;
                      margin-inline: 5px;
                      /* margin-top: 10px; */
                    "
                  >
                    <b-avatar
                      src="/admin.webp"
                      size="25px"
                    />
                    <div style="font-size: 9px; text-align: center">
                      {{ msg.bySend }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- Chat Response -->
              <b-form @submit.prevent="sendMessage">
                <b-form-group>
                  <b-row v-if="previewImageURLs.length > 0">
                    <div
                      v-for="(url, index) in previewImageURLs"
                      :key="index"
                    >
                      <div class="position-relative">
                        <b-img
                          :src="url"
                          alt="Image Preview"
                          width="auto"
                          height="100"
                          class="image-preview mb-1 mx-1 position-relative"
                        />
                        <b-button
                          variant="link"
                          class="position-absolute p-0"
                          style="top: 0; right: 0"
                          @click="removeImage(index)"
                        >
                          <i
                            class="bi bi-x-circle"
                            style="font-size: 1rem; color: red"
                          />
                        </b-button>
                      </div>
                    </div>
                  </b-row>

                  <!-- Image upload -->
                  <div class="d-flex align-items-center">
                    <b-button
                      :size="isSmallScreen ? 'sm' : 'md'"
                      style="box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5)"
                      @click="triggerFileInput"
                    >
                      <i class="bi bi-camera" />
                      <input
                        ref="fileInput"
                        type="file"
                        class="input-file"
                        accept="image/*"
                        style="display: none"
                        multiple
                        @change="previewImage"
                      >
                    </b-button>
                    <b-dropdown
                      no-caret
                      style="box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5)"
                      variant="link"
                      :size="isSmallScreen ? 'sm' : 'md'"
                      class="ml-1"
                    >
                      <template #button-content>
                        <span>😃</span>
                      </template>
                      <VEmojiPicker @select="selectEmoji" />
                    </b-dropdown>

                    <!-- Message textarea -->
                    <b-form-input
                      v-model="responseMessage"
                      :size="isSmallScreen ? 'sm' : 'md'"
                      class="m-1"
                      placeholder="พิมพ์ข้อความของคุณที่นี่..."
                    />

                    <!-- Send button -->
                    <b-button
                      :size="isSmallScreen ? 'sm' : 'md'"
                      style="box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5)"
                      variant="primary"
                      type="submit"
                      class="text-nowrap"
                    >ส่ง</b-button>
                  </div>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>

          <!-- แสดงรูปภาพ -->
          <b-modal
            v-model="showImageModal"
            size="lg"
            hide-footer
            centered
          >
            <template #modal-title>
              <span>รูปภาพ</span>
            </template>
            <b-img
              :src="selectedImage"
              alt="Selected Image"
              fluid-grow
            />
            <template #modal-footer>
              <b-button
                variant="secondary"
                @click="closeImageModal"
              >ปิด</b-button>
            </template>
          </b-modal>
        </div>
      </b-card-body></b-card>
  </b-overlay>
</template>

<script>
import Ws from '@adonisjs/websocket-client'
import moment from 'moment-timezone'
import { VEmojiPicker } from 'v-emoji-picker'
import 'moment/locale/th'
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BButton,
  BCardTitle,
  BCard,
  BAvatar,
  BListGroup,
  BListGroupItem,
  BImg,
  BFormInput,
  BOverlay,
  BCardBody,
  BCollapse,
  BPopover,
  BIconController,
  BPagination,
  BFormSelect,
  BDropdown,
} from 'bootstrap-vue'

export default {
  components: {
    VEmojiPicker,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    BCardTitle,
    BCard,
    BAvatar,
    BListGroup,
    BListGroupItem,
    BImg,
    BFormInput,
    BOverlay,
    BCardBody,
    BCollapse,
    BPopover,
    BIconController,
    BPagination,
    BFormSelect,
    BDropdown,
  },

  data() {
    return {
      filter: null,
      filterOptions: [
        { value: null, text: 'ทั้งหมด' },
        { value: 1, text: 'อินบ็อกซ์' },
        { value: 2, text: 'ยังไม่อ่าน' },
        { value: 3, text: 'ดำเนินการ' },
        { value: 4, text: 'เสร็จสิ้น' },
      ],
      perPage: 10,
      pageOptions: [10, 20, 50, 100],
      totalRows: 1,
      currentPage: 1,
      isSmallScreen: window.innerWidth < 576,
      visible: true,
      socket: null,
      searchQuery: '',
      firstchat: false,
      chatMessages: [],
      responseMessage: '',
      previewImageURLs: [],
      currentChat: [],
      showImageModal: false,
      selectedImage: '',
      show: false,
      UserData: JSON.parse(localStorage.getItem('userData')),
      stream: null,
      btmanage: true,
      btendmanage: true,
      btinbox: false,
      manage: false,
      showmanage: false,
      endmanage: false,
      showendmanage: false,
      inbox: false,
      showstatus: false,
      AlertSound: { soundurl: '/alarm/chatalert.mp3' },
      WsChat: null,
    }
  },
  computed: {
    BaseWsUrl() {
      return this.$store.state.app.BaseWsUrl
    },
    WsMain() {
      return this.$store.state.app.WsMain
    },
    // WsChat() {
    //   return this.$store.state.app.WsChat
    // },
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize)
    await this.CheckWsConnect()
    await this.ChatAll()
    // this.socket = io('http://localhost:3001')
    // this.socket.on('chat message', message => {
    //   console.log(message)
    //   //   this.chatMessages.push(message);
    //   this.currentChat.push(message)
    // })
  },
  methods: {
    Manage(user) {
      if (this.showmanage === user) {
        this.showmanage = false
        this.showstatus = false
      } else {
        this.showmanage = user
        this.showstatus = true
      }
    },
    Inbox(user) {
      this.showstatus = false
      this.btmanage = true
      this.btendmanage = true
      this.btinbox = false
      if (this.showendmanage === user) {
        this.showendmanage = false
      } else {
        this.showendmanage = user
        this.showmanage = false
      }
    },
    getDateHeader(date) {
      const today = moment().startOf('day')
      const yesterday = moment().subtract(1, 'day').startOf('day')
      const targetDate = moment(date).startOf('day')

      if (targetDate.isSame(today)) {
        return 'วันนี้'
      }
      if (targetDate.isSame(yesterday)) {
        return 'เมื่อวาน'
      }
      return moment(date).format('ddd D MMM')
    },
    formatDate(date) {
      return moment(date).format('D MMMM YYYY เวลา HH:mm:ss')
    },
    formatDate2(date) {
      return moment(date).format('HH:mm น.')
    },
    isNewDay(msg, index) {
      if (index === 0) {
        return true
      }
      const currentMessageDate = moment(msg.created_at).format('YYYY-MM-DD')
      const previousMessageDate = moment(
        this.currentChat[index - 1].created_at,
      ).format('YYYY-MM-DD')
      return currentMessageDate !== previousMessageDate
    },
    handleResize() {
      this.isSmallScreen = window.innerWidth < 990
      if (window.innerWidth > 990) {
        this.visible = true
      } else {
        this.visible = false
      }
    },
    async ChatAll() {
      this.show = true
      const params = {
        search: this.searchQuery,
        status: this.filter,
        perPage: this.perPage,
        page: this.currentPage,
      }
      const { data: res } = await this.$http.get('Chats/getChat', { params })
      this.chatMessages = res.data
      this.totalRows = res.totalCount
      this.show = false
    },
    GetImg(pathfile, filename) {
      // http://127.0.0.1:4020/api https://api.shibuya24.com/api
      const matches = filename.match(
        /^data:image\/([A-Za-z-+\/]+);base64,(.+)$/,
      )
      if (!matches || matches.length !== 3) {
        return `https://api.shibuya24.com/api/viewimg?pathfile=${pathfile}/${filename}`
      }
      return filename
    },
    async CheckWsConnect() {
      if (!this.WsMain) {
        await this.ConnectWS()
      }
      if (!this.WsChat) {
        await this.SubWsOnChat()

        await this.WsOnChat()
      } else {
        await this.WsOnChat()
      }
    },
    async ConnectWS() {
      const Token = localStorage.getItem('token')
      if (Token) {
        // console.log("Ws", Ws)
        // const BaseWsUrl = Ws('wss://api.shibuya24.com')
        const ws = Ws(this.BaseWsUrl)
        await ws.withJwtToken(Token).connect()

        // ws.on('open', () => {
        //   console.log('Connection established')
        // })
        // ws.on('error', error => {
        //   console.log('Connection Error', error)
        // })

        // ws.on('close', event => {
        //   console.log('Connection closed', event)
        // })
        this.$store.commit('app/SET_WSMAIN', ws)
      }
    },
    SubWsOnChat() {
      if (this.WsMain && this.WsMain.getSubscription(`chatAdmin:${this.UserData.agent_id}`)) {
        this.WsChat = this.WsMain.getSubscription(`chatAdmin:${this.UserData.agent_id}`)
      } else {
        this.WsChat = this.WsMain.subscribe(`chatAdmin:${this.UserData.agent_id}`)
      }
      // const UserData = JSON.parse(localStorage.getItem('userData'))
      // const WsChat = this.WsMain.subscribe(
      //   `chatAdmin:${this.UserData.agent_id}`,
      // )
      // this.WsChatfrist = this.WsMain.subscribe(`fristchat:${UserData.agent_id}`)
      // this.$store.commit('app/SET_WSCHAT', this.WsChat)

      // this.WsChatfrist.emit('message', msg)
    },
    WsOnChat() {
      try {
        if (!this.WsChat) {
          console.warn('⚠️ WsChat ยังไม่ถูก subscribe')
          return
        }

        this.WsChat.on('open', () => {
          console.log('WsOnChat established')
        })

        this.WsChat.on('message', message => {
          if (message.roleSend == 'user') {
            const audio = new Audio(this.AlertSound.soundurl)
            audio.play()
          }
          const CheckData = this.chatMessages.findIndex(
            ele => ele.userID == message.userID,
          )
          if (CheckData < 0) {
            this.chatMessages.unshift(message)
          } else {
            this.chatMessages.splice(CheckData, 1, { ...message })
          }
          this.chatMessages.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at),
          )
        })

        this.WsChat.on('error', error => {
          console.error('WsChat error', error)
          this.startReconnect()
        })

        this.WsChat.on('close', () => {
          console.warn('WsChat closed')
          this.startReconnect()
        })
      } catch (err) {
        console.log('❌ Error in WsOnChat', err)
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    async selectChat(item) {
      this.show = true
      if (item) {
        const params = {
          room: item.room,
        }
        const { data: res } = await this.$http.get('Chats/getChatUser', {
          params,
        })

        if (res.data) {
          const targetChat = this.chatMessages.find(
            x => x.unseenMsgs === item.unseenMsgs,
          )

          if (targetChat) {
            targetChat.unseenMsgs = 0
          }
          this.currentChat = res.data
          this.socket = item
          this.firstchat = true
          if (!this.WsMain) {
            await this.ConnectWS()
          }
          this.stream = this.WsMain.getSubscription(item.room)
          if (!this.stream) {
            this.stream = this.WsMain.subscribe(item.room)
            this.stream.on('message', message => {
              if (message && this.socket && message.userID == this.socket.userID) {
                this.currentChat.push(message)
                this.socket.checkChat = message.checkChat
                this.socket.agentChat = message.agentChat
              }

              this.$nextTick(() => {
                const chatBox = this.$refs.chatHistoryBox
                chatBox.scrollTop = chatBox.scrollHeight
              })
            })
            this.stream.on('open', () => {
              console.log('WebSocket connection opened')
            })

            this.stream.on('error', error => {
              console.error('WebSocket error:', error)
            })
            this.stream.on('reconnect', attempt => {
              console.log('Reconnecting... Attempt:', attempt)
            })
            this.stream.on('close', () => {
              if (this.UserData) {
                this.stream.connect()
              }
            })
          }
          this.stream.on('close', () => {
            console.warn('⚠️ WebSocket disconnected')
          })

          // ฟัง event error (เกิดข้อผิดพลาด)
          this.stream.on('error', error => {
            console.error('❌ WebSocket error:', error)
          })
          this.show = false
        }
        this.$nextTick(() => {
          const chatBox = this.$refs.chatHistoryBox
          chatBox.scrollTop = chatBox.scrollHeight
        })
      } else {
        this.show = false
        this.stream.close()
        this.socket = null
        this.firstchat = false
      }

      // this.firstchat = true
      // this.currentChat = [item]
    },
    startReconnect() {
      if (!this.WsChat) {
        this.WsChat = setInterval(() => {
          if (!this.WsMain || this.WsMain.isConnected()) {
            this.ConnectWS() // เรียกเชื่อมต่อใหม่
          }
        }, 3000) // ลองเชื่อมใหม่ทุก 3 วินาที
      }
    },
    EndManage(item, value) {
      this.socket.checkChat = value
      if (this.socket.checkChat == 1) {
        this.socket.agentChat = this.UserData.name
      } else {
        this.socket.agentChat = null
      }
      this.$http.post('Chats/update', this.socket)
    },

    async sendMessage() {
      if (!this.WsMain) {
        await this.ConnectWS()
      }
      this.stream = this.WsMain.getSubscription(this.socket.room)
      if (!this.stream) {
        this.stream = this.WsMain.subscribe(this.socket.room)
      }
      if (this.previewImageURLs.length > 0) {
        this.previewImageURLs.forEach(imageURL => {
          const imageMessage = {
            agent_id: this.socket.agent_id,
            userID: this.socket.userID,
            username: this.socket.username,
            message: '',
            roleSend: 'admin',
            fileimg: [imageURL],
            bySend: this.UserData.name,
          }
          this.currentChat.push(imageMessage)
          this.stream.emit('message', imageMessage)
        })
        this.previewImageURLs = []
      }

      if (this.responseMessage.trim()) {
        const textMessage = {
          agent_id: this.socket.agent_id,
          userID: this.socket.userID,
          username: this.socket.username,
          message: this.responseMessage.trim(),
          roleSend: 'admin',
          fileimg: [],
          bySend: this.UserData.name,
        }

        this.currentChat.push(textMessage)
        this.stream.emit('message', textMessage)
      }

      this.responseMessage = ''
      this.$nextTick(() => {
        const chatBox = this.$refs.chatHistoryBox
        chatBox.scrollTop = chatBox.scrollHeight
      })
    },

    previewImage(event) {
      const { files } = event.target
      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const filepath = files[i]

          const reader = new FileReader()
          reader.onload = e => {
            this.previewImageURLs.push(e.target.result)
          }
          reader.readAsDataURL(filepath)
        }
      } else {
        this.previewImageURLs = []
      }
    },

    removeImage(index) {
      this.previewImageURLs.splice(index, 1)
    },

    openImageModal(image) {
      this.showImageModal = true
      const imgs = this.GetImg('chat_img', image)
      this.selectedImage = imgs
    },
    closeImageModal() {
      this.showImageModal = false
    },
    selectEmoji(dataEmoji) {
      if (this.responseMessage) {
        this.responseMessage += dataEmoji.data
      } else {
        this.responseMessage = dataEmoji.data
      }
    },
  },
}
</script>

<style lang="scss">
.image-preview {
  border: 2px dashed #ccc;
  border-radius: 8px;
  max-width: 100%;
  padding: 10px;
}

.chat-wrapper {
  .chat-history {
    border-right: 1px solid #f0f0f0;
    // background: #948ff50e;
    border-radius: 10px;
  }

  .chat-history-box {
    padding: 10px;
    border-top: 1px solid #f0f0f0;
    height: 60vh;
    overflow-y: auto;
    margin-bottom: 20px;
  }

  .chat-history-box::-webkit-scrollbar {
    width: 6px;
  }

  .chat-history-box::-webkit-scrollbar-track {
    // background: #f0f0f0;
    border-radius: 10px;
  }

  .chat-history-box::-webkit-scrollbar-thumb {
    background: #0000000e;
    border-radius: 10px;
  }

  .chat-history-box::-webkit-scrollbar-thumb:hover {
    background: #5a54c542;
  }

  .message {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .message-text {
    padding-inline: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-radius: 8px;
  }
  .user-message .message-text {
    text-align: start;
    max-width: 30vh;
    background-color: #f1f1f1;
  }

  .admin-message .message-text {
    text-align: start;
    max-width: 30vh;
    background: linear-gradient(to bottom, #948ff5, #7367f0);
    color: #fff;
  }
  .active-chat {
    background: linear-gradient(to bottom, #948ff5, #7367f0);
    border: 1px solid #948ff5;
    color: white;
    transition: all 0.3s ease;
  }

  .active-chat:hover {
    background: linear-gradient(to bottom, #948ff5, #7367f0);
    border: 1px solid #948ff5;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    color: #ffffff;
  }

  .online-status {
    border: 3px solid green;
    border-radius: 50%;
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.5);
  }

  .offline-status {
    border: 3px solid rgb(255, 255, 255);
    border-radius: 50%;
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.5);
  }

  .user-message {
    justify-content: flex-start;
    text-align: right;
  }

  .admin-message {
    justify-content: flex-end;
    text-align: left;
  }
}

.e-card {
  margin: 100px auto;
  background: transparent;
  box-shadow: 0px 8px 28px -9px rgba(0, 0, 0, 0.45);
  position: relative;
  width: 240px;
  height: 330px;
  border-radius: 16px;
  overflow: hidden;
}

.wave {
  position: absolute;
  width: 540px;
  height: 700px;
  opacity: 0.6;
  left: 0;
  top: 0;
  margin-left: -50%;
  margin-top: -70%;
  background: linear-gradient(744deg, #af40ff, #5b42f3 60%, #00ddeb);
}

.infotop {
  text-align: center;
  font-size: 20px;
  position: absolute;
  top: 3.7em;
  left: 0;
  right: 0;
  color: rgb(255, 255, 255);
  font-weight: 600;
}

.name {
  font-size: 14px;
  font-weight: 100;
  position: relative;
  top: 0.5em;
  text-transform: lowercase;
}

.wave:nth-child(2),
.wave:nth-child(3) {
  top: 210px;
}

.playing .wave {
  border-radius: 40%;
  animation: wave 3000ms infinite linear;
}

.wave {
  border-radius: 40%;
  animation: wave 55s infinite linear;
}

.playing .wave:nth-child(2) {
  animation-duration: 4000ms;
}

.wave:nth-child(2) {
  animation-duration: 50s;
}

.playing .wave:nth-child(3) {
  animation-duration: 5000ms;
}

.wave:nth-child(3) {
  animation-duration: 45s;
}

@keyframes wave {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 990px) {
  .chat-wrapper {
    .chat-history {
      border-right: 1px solid #f0f0f000;
    }

    .chat-history-box {
      padding: 5px;
      height: 50vh;
      overflow-y: auto;
      margin-bottom: 20px;
    }
    .user-message .message-text {
      text-align: start;
      max-width: 25vh;
    }

    .admin-message .message-text {
      text-align: start;
      max-width: 25vh;
    }
  }
  .head {
    border-top: 1px solid #f0f0f0;
  }
}
</style>
